<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        
        <tr>
          <th scope="row">제목</th>
          <td>
            <div class="item">
              {{ inquiry.questionTitle }}
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">등록일자</th>
          <td>
            <div class="item">
              {{ inquiry.createDate }}
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">이메일</th>
          <td>
            <div class="item">
              {{ inquiry.userEmail }}
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">문의 내용</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="10" class="i_ta type_full lineless" placeholder="상세 내용을 입력하세요." v-model="inquiry.questionContent" disabled></textarea>
            </div>
          </td>
        </tr>
        <tr v-if="inquiry.answerDate">
          <th scope="row">답변일자</th>
          <td>
            <div class="item">
              {{ inquiry.answerDate }}
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">문의 답변</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="10" class="i_ta type_full lineless" placeholder="답변 내용을 입력하세요." v-model="answer"></textarea>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a href="#none" class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="answerInquiry">저장</button>
      <button type="reset" class="bt_base gray large_h" @click="deleteInquiry">삭제</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
const adminInquiryModule = 'adminInquiryModule'

export default {
  data (){
    return {
      inquirySeq: this.$route.query.inquirySeq,
      answer: ''
    }
  },
  methods: {
    ...mapActions(adminInquiryModule, [
      'requestAnswerInquiry',
      'requestInquiry',
      'requestDeleteInquiries'
    ]),

    toList () {
      this.$router.push({ name: "InquiryManageListPage" })
    },

    async answerInquiry() {
      const answer = this.answer.replace(/\n/g, '<br>')
      const inquirySeq = this.inquirySeq

      const result = await this.requestAnswerInquiry({ inquirySeq, answer })
      if (result) {
        this.$router.push({ name: "InquiryManageListPage" })
      }
    },

    async deleteInquiry () {
      if (confirm("팝업을 삭제하시겠습니까?")) {
        let deleteList = []
        deleteList.push(this.inquirySeq)
        if (await this.requestDeleteInquiries(deleteList)) {
          alert("삭제가 완료됐습니다")
          this.$router.push({ name: 'InquiryManageListPage' })
        }
      }
    }
  },

  computed: {
    ...mapState(adminInquiryModule, ['inquiry'])
  },

  async mounted() {
    if (this.$route.query.inquirySeq) {
      await this.requestInquiry(this.$route.query.inquirySeq);

      if (this.inquiry.answer) {
        this.answer = this.inquiry.answer.replace(/<br\s*\/?>/g, `\n`)
      }
      this.inquiry.questionContent = this.inquiry.questionContent.replace(/<br\s*\/?>/g, `\n`)
    }
  }
}
</script>
<style lang="">
    
</style>